import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
export const MyTextField = (props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(props.value);

  const handleChange = (value) => {
    let isValid = true;
    if (props.regExp) {
      let regEx = new RegExp(props.regExp);
      isValid = regEx.test(value);
    }
    if (props.min) {
      if (Number(value) < Number(props.min)) {
        isValid = false;
      }
    }
    if (props.max) {
      if (Number(value) > Number(props.max)) {
        isValid = false;
      }
    }
    if (props.maxLength) {
      if (value && value.length > props.maxLength) {
        isValid = false;
      }
    }
    if (isValid) {
      setValue(value);
      props.onChange(value);
    }
  };

  const inputMode = props.inputMode ? props.inputMode : "text";

  useEffect(() => {
    if (!props.value) setValue(props.value);
    else if (!!props.value && value !== props.value) setValue(props.value);
  }, [props.value]);

  return (
    <TextField
      disabled={props.disabled}
      autoComplete={props.autoComplete ?? "off"}
      required={props.required}
      name={props.userFieldName === true ? props.label : undefined}
      size={props.size ? props.size : "medium"}
      style={{ width: "100%", margin: "1rem 0", ...props.style }}
      className={props.className}
      helperText={props.helperText}
      error={!!props.helperText}
      type={props.type}
      value={value}
      variant="outlined"
      label={props.label}
      onChange={(e) => handleChange(e.target.value)}
      placeholder={props.placeholder}
      onKeyPress={props.onKeyPress}
      multiline={props.multiline}
      rows={props.rows}
      inputProps={{
        maxLength: props.maxLength,
        inputMode: inputMode,
      }}
      sx={{
          ...props.sx
      }}
    />
  );
};
